export class RemoveEventQuestionAttachmentRequest{
  EventID: number = -1;
  AuditResultID: number = -1;
  AuditResultDetailID: number = -1;
  AttachmentID: number = -1;
  AttachmentGUID: string = '';
  constructor(values: Object = {}){
    Object.assign(this, values);
  }
}
